var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C5.34375 7 5.63802 6.8776 5.88281 6.63281C6.1276 6.38802 6.25 6.09375 6.25 5.75C6.25 5.40625 6.1276 5.11198 5.88281 4.86719C5.63802 4.6224 5.34375 4.5 5 4.5C4.65625 4.5 4.36198 4.6224 4.11719 4.86719C3.8724 5.11198 3.75 5.40625 3.75 5.75C3.75 6.09375 3.8724 6.38802 4.11719 6.63281C4.36198 6.8776 4.65625 7 5 7ZM5 11.5938C6.27083 10.4271 7.21354 9.36719 7.82813 8.41406C8.44271 7.46094 8.75 6.61458 8.75 5.875C8.75 4.73958 8.38802 3.8099 7.66406 3.08594C6.9401 2.36198 6.05208 2 5 2C3.94792 2 3.0599 2.36198 2.33594 3.08594C1.61198 3.8099 1.25 4.73958 1.25 5.875C1.25 6.61458 1.55729 7.46094 2.17188 8.41406C2.78646 9.36719 3.72917 10.4271 5 11.5938ZM5 13.25C3.32292 11.8229 2.07031 10.4974 1.24219 9.27344C0.414062 8.04948 0 6.91667 0 5.875C0 4.3125 0.502604 3.06771 1.50781 2.14063C2.51302 1.21354 3.67708 0.75 5 0.75C6.32292 0.75 7.48698 1.21354 8.49219 2.14063C9.4974 3.06771 10 4.3125 10 5.875C10 6.91667 9.58594 8.04948 8.75781 9.27344C7.92969 10.4974 6.67708 11.8229 5 13.25Z",
    fill: "#1D1D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationoutline);
export default __webpack_public_path__ + "static/media/locationoutline.646e12dc566bcb3f251cb8bea7ddecfd.svg";
export { ForwardRef as ReactComponent };